module.exports = __webpack_public_path__ + "assets/img/cam@2x.a7b4dadc.png";